import React from "react";
import { ClipLoader } from "react-spinners";
import { FileProcessingStatus, IAttachmentFile } from "../..";
import { RemoveButton } from "../../../../../components/Buttons/RemoveButton";
import { strings } from "../../../../../localisation";
import { AttachmentItemLi, AttachmentName, AttachmentSize, AttachmentStatus } from "./AttachmentItem.styles";

export interface IAttachmentItemProps {
    Attachment: IAttachmentFile;
    Disabled?: boolean;
    OnRemoveAttachment?: (file: IAttachmentFile) => void;
}

export const AttachmentItem = ({ Attachment, Disabled, OnRemoveAttachment }: IAttachmentItemProps) => {

    let attachmentAction: React.ReactNode;

    switch (Attachment.ProcessingStatus) {
        case FileProcessingStatus.Pending:
        case FileProcessingStatus.Uploading:
        case FileProcessingStatus.Deleting:
            attachmentAction = <ClipLoader size={15} />;
            break;
        case FileProcessingStatus.Uploaded:
            attachmentAction = OnRemoveAttachment && <RemoveButton
                AriaLabel={strings.formatString(strings.Action_Attachments_Remove, Attachment.File.name) as string}
                Disabled={Disabled}
                OnClick={() => {
                    if (!Disabled) {
                        OnRemoveAttachment(Attachment);
                    }
                }}
            />;
            break;
    }

    const formatBytes = (bytes?: number, decimals = 2) => {
        if (!bytes || bytes === 0) { return ""; }

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    return (
        <AttachmentItemLi title={Attachment.File.name} Disabled={Disabled}>
            <AttachmentName>
                {Attachment.File.name}
            </AttachmentName>
            <AttachmentSize>
                ({formatBytes(Attachment.File.size)})
            </AttachmentSize>
            <AttachmentStatus>
                {attachmentAction}
            </AttachmentStatus>
        </AttachmentItemLi>
    );
};
